module.exports = __webpack_public_path__ + "static/media/starttrans.32042384.svg";